import { render, staticRenderFns } from "./IconTransfers.vue?vue&type=template&id=0f3c8629&"
import script from "./IconTransfers.vue?vue&type=script&lang=ts&"
export * from "./IconTransfers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports